module.exports = __webpack_public_path__ + "img/tick_blue.98921ea5.svg";